import React, {useState, useEffect, useCallback, useRef} from 'react';

import useChannel from './useChannel.js';
import usePulseAnimation from './usePulseAnimation.js';
import NavbarBadge from './NavbarBadge.jsx';
import TaskNotification, { NoTaskNotifications } from './TaskNotification.jsx';

import {
  long_running_task_list_json_path,
  long_running_task_delete_path,
  long_running_task_mark_as_read_toggle_path,
  long_running_task_clear_all_path,
  long_running_task_retry_path
} from '~/routes';

const LongRunningTaskNotificationMenu = ({}) => {
  const [loaded, setLoaded] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [activePulse, setActivePulse] = usePulseAnimation();
  const lastRefresh = useRef(null);
  const componentRef = useRef(true);

  const updateLastRefresh = useCallback( (tasks) => {
    lastRefresh.current = new Date(Math.max(0, ...(tasks.map(t => new Date(t.updated_at).getTime())))).toISOString();
  }, [lastRefresh]);

  useChannel(setNotifications, setActivePulse, loaded, lastRefresh, updateLastRefresh, componentRef);

  const fetchNotifications = () => {
    jQuery
      .get(long_running_task_list_json_path(), (res) => {
        const { tasks } = res;
        updateLastRefresh(tasks);
        setNotifications(tasks);
        setLoaded(true);
      })
      .fail((err) => {
        console.error(err)
      });
  }

  const handleRetryClick = (e,i,v) => {
    const { id } = v;
    e.stopPropagation();

    if (confirm(`${I18n.t('retry')} ${v.name || v.id}?`)) {
      jQuery
      .post(long_running_task_retry_path({ id: id }), () => {
        fetchNotifications();
      })
      .fail(() => {
        alert(I18n.t('error_retry_task'));
      });
    }
  };

  const handleDeleteClick = (e,i,v) => {
    const { id } = v;
    e.stopPropagation();

    if (confirm(`${I18n.t('delete')} ${v.name || v.id}?`)) {
      jQuery
      .post(long_running_task_delete_path({ id: id }), () => {
        setNotifications(currentNotifications => currentNotifications.filter(notification => notification.id !== id));
        fetchNotifications();
      })
      .fail(() => {
        alert(I18n.t('error_delete_task'));
      });
    }
  };

  const handleClearALLClick = (e) => {
    e.stopPropagation();

    if (confirm(I18n.t('clear_all_confirm'))) {
      jQuery
        .post(long_running_task_clear_all_path(), () => {
          setNotifications([]);
          fetchNotifications();
        })
        .fail(() => {
          alert(I18n.t('error_delete_task'));
        });
    }
  };

  const handleMarkAsRead = (e,i,v) => {
    e.stopPropagation();
    const { id, read } = v;
    if (!read) toggleRead(id);
  }

  const toggleRead = (id) => {
    jQuery
    .post(long_running_task_mark_as_read_toggle_path({ id: id }), () => {
      fetchNotifications();
    })
    .fail(() => {
      alert(I18n.t('error_mark_task_read_toggle'));
    });
  }

  useEffect(() => {
    setLoaded(false);
    fetchNotifications();
    return () => {
      componentRef.current = false;
    }
  }, [])

  const unreadCount = notifications.filter(n => !n.read).length;
  
  return (
        <>
          <NavbarBadge {...{unreadCount, activePulse, loaded}} />
          <div
            className="dropdown-menu p-0 m-0 border-0 notification-menu"
          >
            <div className='p-1 text-bold notification-header'>
              <span className='text-uppercase' style={{fontSize: '1.25rem'}}>{I18n.t('long_running_tasks')}</span>

              {notifications.length > 0 &&
                <span onClick={handleClearALLClick} 
                style={{
                  fontSize: '1rem',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  fontWeight: 400
                }}
                className='btn-link'>
                  {I18n.t('clear_all')}
                </span>
              }
            </div>
            <div
             style={{
                lineHeight: "normal",
                overflowY: "auto",
                maxHeight: "calc(100vh - 150px)",
                scrollbarColor: '#a6a8b2 #f9f9f9',
                scrollbarWidth: 'thin'
              }}
            >
              {loaded && notifications.length == 0 && <NoTaskNotifications />}
              {loaded && notifications.map((notification, index) => (
                <TaskNotification 
                  notification={notification}
                  key={`task-notification-${notification.id}`}
                  index={index}
                  handleDeleteClick={handleDeleteClick}
                  handleRetryClick={handleRetryClick}
                  handleMarkAsRead={handleMarkAsRead}
                  noBorder={index + 1 == notifications.length}
                />
              ))}
            </div>
          </div>
        </>
  );
};

export default LongRunningTaskNotificationMenu;
